module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('mu-appbar', [_c('mu-icon', {
    staticStyle: {
      "margin-bottom": "-0.05rem"
    },
    attrs: {
      "slot": "left",
      "value": "keyboard_arrow_left",
      "color": "white"
    },
    on: {
      "click": _vm.goback
    },
    slot: "left"
  }), _vm._v(" "), _c('span', {
    staticClass: "topT"
  }, [_vm._v("激活")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "bigpages"
  }, [_c('div', {
    staticClass: "cardinfo"
  }, [_c('div', {
    staticClass: "h phone"
  }, [_vm._v("姓名：" + _vm._s(_vm.UserName))]), _vm._v(" "), _c('div', {
    staticClass: "h phone"
  }, [_vm._v("卡号：" + _vm._s(_vm.Card_no))]), _vm._v(" "), _c('div', {
    staticClass: "h phone"
  }, [_vm._v("卡类：" + _vm._s(_vm.cardkind))])]), _vm._v(" "), _c('div', {
    staticClass: "phone h"
  }, [_vm._v("手机号："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cardPhone),
      expression: "cardPhone"
    }],
    staticClass: "phonetext pw",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cardPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cardPhone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "phone h",
    staticStyle: {
      "padding-bottom": "0.1rem"
    }
  }, [_vm._v(" 验证码："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activationCode),
      expression: "activationCode"
    }],
    staticClass: "phonetext",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.activationCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.activationCode = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "vertical"
  }, [_vm._v("|")]), _c('div', {
    staticClass: "Obtain",
    on: {
      "click": _vm.Obtain
    }
  }, [_vm._v("获取")])]), _vm._v(" "), _c('div', {
    staticClass: "h activationc",
    on: {
      "click": _vm.ActivateCellPhone
    }
  }, [_vm._v("激活")])]), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": _vm.TellUser,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2278fdbe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/NonVerified/Activation.vue
// module id = 1447
// module chunks = 18